import ENDPOINTS from 'api/endpoints';
import { doDelete, doGet } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type {
  AgentBuilderConversationsResponse,
  AgentBuilderConversationWithMessages,
  ListConversationsOptions,
} from './types';

export const getAgentBuilderConversations = (
  accountId: string,
  projectId: string,
  options: ListConversationsOptions = {},
) => {
  const { limit = 20, offset = 0, branchId } = options;

  return doGet<AgentBuilderConversationsResponse>(
    generateNextPath(ENDPOINTS.AGENT_BUILDER_CONVERSATIONS, {
      accountId,
      projectId,
    }),
    LOGGER_TYPE.AGENT_STREAM,
    {
      prefix: 'sourcerer',
      version: 'v1',
      params: {
        limit,
        offset,
        ...(branchId && { branchId }),
      },
    },
  );
};

export const getAgentBuilderConversation = (
  accountId: string,
  projectId: string,
  conversationId: string,
) => {
  return doGet<AgentBuilderConversationWithMessages>(
    generateNextPath(ENDPOINTS.AGENT_BUILDER_CONVERSATION, {
      accountId,
      projectId,
      conversationId,
    }),
    LOGGER_TYPE.AGENT_STREAM,
    {
      prefix: 'sourcerer',
      version: 'v1',
    },
  );
};

export const deleteAgentBuilderConversation = (
  accountId: string,
  projectId: string,
  conversationId: string,
) => {
  return doDelete<void>(
    generateNextPath(ENDPOINTS.AGENT_BUILDER_CONVERSATION, {
      accountId,
      projectId,
      conversationId,
    }),
    LOGGER_TYPE.AGENT_STREAM,
    {},
    {
      prefix: 'sourcerer',
      version: 'v1',
    },
  );
};
